var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSplitter',{staticStyle:{"display":"flex","height":"100%","overflow":"hidden"},attrs:{"margin":30,"horizontal":_vm.horizontal}},[_c('Groups',{attrs:{"slot":"left-pane"},on:{"choice":_vm.choice},slot:"left-pane"}),_c('GroupInfo',{attrs:{"slot":"right-pane","list":_vm.cur_list},slot:"right-pane"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }